export default "__VITE_ASSET__F_DZT4qn__"